
import { Button } from "@/components/ui/button";
import { Plus, RefreshCw, Users } from "lucide-react";
import ViewToggle from "@/components/contacts/ViewToggle";

interface ContactsPageHeaderProps {
  viewMode: "card" | "list" | "details";
  onViewChange: (view: "card" | "list" | "details") => void;
  onAddContact: () => void;
  onRefresh?: () => void;
}

const ContactsPageHeader = ({ viewMode, onViewChange, onAddContact, onRefresh }: ContactsPageHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <Users className="h-5 w-5 text-muted-foreground flex-shrink-0" />
        <p className="text-muted-foreground hidden md:block">Manage your business contacts in one place</p>
      </div>

      <div className="flex items-center justify-end gap-2 md:gap-3">
        <ViewToggle view={viewMode} onViewChange={onViewChange} />
        {onRefresh && (
          <Button variant="outline" size="icon" onClick={onRefresh}>
            <RefreshCw size={16} />
          </Button>
        )}
        <Button size="icon" onClick={onAddContact}>
          <Plus size={16} />
        </Button>
      </div>
    </div>
  );
};

export default ContactsPageHeader;
